import React from 'react';
import ReactDOM from 'react-dom/client';
import AudioPlayer from './AudioPlayer';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<AudioPlayer />);